export var IdLeagueGifts;
(function (IdLeagueGifts) {
    IdLeagueGifts["LeagueFreeGift"] = "Free";
    IdLeagueGifts["LeagueGoldGift"] = "Gold";
    IdLeagueGifts["LeaguePremiumOffer"] = "PremiumOffer";
})(IdLeagueGifts || (IdLeagueGifts = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdLeagueGifts.ts
// module id = 185
// module chunks = 3